// Single Face Swap Target Image Loader
// This loads the target image for single face swap
(function() {
  console.log('Single Face Target Loader: Initializing...');
  
  // Function to get the target image
  window.getSingleFaceTargetImage = async function() {
    // Check if we already have a loaded target image
    if (window.singleFaceSwapTargetBase64) {
      console.log('Using pre-loaded target image');
      return window.singleFaceSwapTargetBase64;
    }
    
    // For single face swap, the backend expects the actual base64 image
    // According to the guide: "targetImage": "data:image/jpeg;base64,..."
    
    try {
      // Load the actual target image from local file
      // This is the specific target template image provided
      const targetImagePath = '/Users/alexanderburum-auensen/Desktop/photo_2025-08-16_14-29-44.jpg';
      
      // For web environment, we need to use a URL or embedded base64
      // Since we can't access local files directly from browser, we'll use a CDN URL
      // or embed the base64 directly
      
      // First check if we have the embedded base64
      if (window.SINGLE_FACE_TARGET_BASE64) {
        console.log('Using embedded target image base64');
        window.singleFaceSwapTargetBase64 = window.SINGLE_FACE_TARGET_BASE64;
        return window.SINGLE_FACE_TARGET_BASE64;
      }
      
      // Otherwise try to fetch from CDN
      const targetUrl = 'https://cdn.shopify.com/s/files/1/0626/3416/4430/files/photo_2025-08-16_14-29-44.jpg?v=1755509833';
      
      console.log('Fetching target image from:', targetUrl);
      const response = await fetch(targetUrl);
      
      if (!response.ok) {
        console.warn('Could not fetch target image, using server default');
        return 'USE_DEFAULT_TEMPLATE';
      }
      
      const blob = await response.blob();
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      
      // Cache for future use
      window.singleFaceSwapTargetBase64 = base64;
      console.log('Target image loaded successfully');
      return base64;
      
    } catch (error) {
      console.error('Error loading target image:', error);
      // Fallback to server default
      return 'USE_DEFAULT_TEMPLATE';
    }
  };
  
  // Auto-load on DOMContentLoaded for single face swap template
  document.addEventListener('DOMContentLoaded', async function() {
    const buyButtons = document.querySelector('buy-buttons');
    const templateSuffix = buyButtons ? buyButtons.getAttribute('template') : '';
    
    if (templateSuffix === 'single-face-swap') {
      console.log('Single face swap template detected, pre-loading target image...');
      await window.getSingleFaceTargetImage();
    }
  });
})();